import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "./assets/css/admin-dark-shell.css";
import { vMaska } from "maska/vue"
import MaterialDashboard from "./material-dashboard";
import money from 'v-money3'
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';
import Lara from '@primevue/themes/lara';
import JsonExcel from "vue-json-excel3";
import ConfirmationService from 'primevue/confirmationservice';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import LoggingPlugin from './plugins/LoggingPlugin';
import './registerServiceWorker'

const appInstance = createApp(App);
appInstance.component("downloadExcel", JsonExcel);
appInstance.use(VueSweetalert2);
appInstance.use(store);
appInstance.use(router);
appInstance.use(
  PrimeVue, {
    theme: {
        preset: Lara,
        options: {
            prefix: 'p',
            cssLayer: false,
            darkModeSelector: '.my-app-dark',
          },
    },
 }
);
appInstance.use(ToastService);
appInstance.use(MaterialDashboard);
appInstance.use(ConfirmationService);
appInstance.use(LoggingPlugin);
appInstance.directive(vMaska);
appInstance.directive('tooltip', Tooltip);
appInstance.use(money);
appInstance.mount("#app");
